export default {"src":"/_next/static/media/phone-icon.6979230f.svg","height":474,"width":474};